"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ChipGroupCommon", {
  enumerable: true,
  get: function get() {
    return _Flex.FlexCommon;
  }
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Chip = require("../Chip.util");
var _Flex = _interopRequireWildcard(require("../../../components/Flex"));
var _excluded = ["children", "defaultSelected", "direction", "name", "onCheck", "required", "selected", "selectedColor", "size", "width", "gap"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ChipGroup = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    defaultSelected = props.defaultSelected,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? "row" : _props$direction,
    name = props.name,
    onCheck = props.onCheck,
    required = props.required,
    selected = props.selected,
    selectedColor = props.selectedColor,
    size = props.size,
    _props$width = props.width,
    width = _props$width === void 0 ? "fit-content" : _props$width,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 8 : _props$gap,
    otherProps = _objectWithoutProperties(props, _excluded);
  var flexProps = _objectSpread({
    direction: direction,
    ref: ref,
    width: width,
    gap: gap
  }, otherProps);
  return /*#__PURE__*/_react.default.createElement(_Chip.ChipContext.Provider, {
    value: {
      defaultSelected: defaultSelected,
      name: name,
      onCheck: onCheck,
      required: required,
      selected: selected,
      selectedColor: selectedColor,
      size: size,
      type: "radio"
    }
  }, /*#__PURE__*/_react.default.createElement(_Flex.default, flexProps, children));
});
ChipGroup.displayName = "ChipGroup";
var _default = exports.default = ChipGroup;